import {
  Box,
  Drawer,
  Stack,
  Typography,
} from "@mui/material";
import { Dayjs } from "dayjs";
import DatePickerEl from "../../ui/DatePickerEl";

export const ReturnFilter = ({
  open,
  startDate,
  endDate,
  handleDateChange,
  onClose,
}: {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  handleDateChange: (time: Dayjs | null, type: string) => void;
  onClose: () => void;
  open: boolean;
}) => {
  return (
    <Drawer open={open} onClose={onClose} anchor="right">
      <Box
        sx={{
          padding: "30px 20px",
          width: "260px",
        }}
      >
        <Stack rowGap={"20px"}>
          <Typography fontSize={"24px"}>Filters</Typography>
          <Stack
            justifyContent={"center"}
            alignItems={"center"}
            flexWrap={"wrap"}
            columnGap={"40px"}
            rowGap={"40px"}
          >
            <DatePickerEl
              defaultDate={startDate}
              handleChange={(time) => handleDateChange(time, "start")}
              label="From"
            />
            <DatePickerEl
              defaultDate={endDate}
              handleChange={(time) => handleDateChange(time, "end")}
              label="To"
            />
          </Stack>
        </Stack>
      </Box>
    </Drawer>
  );
};
